import { isValidMarketStatus } from '@morfi/contract-sdk';
import { type QuoteVenue, resolveQuoteVenue } from '@morfi/market-math';

export type CurrentChartLiquidityModel = QuoteVenue;

export function resolveCurrentChartLiquidityModel(input: {
  marketStatus: string | undefined;
  outcomeIndex: number;
  winnerOutcomeIndex: number | null | undefined;
  hasCpSwapPool: boolean;
}): CurrentChartLiquidityModel | null {
  if (input.marketStatus === undefined) return null;
  const lifecycle = input.marketStatus === 'baking' ? 'backing' : input.marketStatus;
  if (!isValidMarketStatus(lifecycle)) return null;
  const venue = resolveQuoteVenue({
    lifecycle,
    outcomeIndex: input.outcomeIndex,
    winningOutcomeIndex: input.winnerOutcomeIndex ?? null,
    bondingCurveClosed: input.hasCpSwapPool || lifecycle !== 'trading',
    hasCpSwapPool: input.hasCpSwapPool,
  });
  return venue.available ? venue.value : null;
}
